import { configureStore, ThunkAction, Action, createListenerMiddleware } from '@reduxjs/toolkit';

import {
  meetingsApi,
  racesApi,
  userApi,
  partnersApi,
  raceApi,
  racePreviewApi,
  eventsApi,
  oddsApi,
  runnersApi,
  performancesApi,
  editorialContentsApi,
  fixedOddsApi,
} from '@api/services';

import { rootReducer, RootState } from './rootReducer';

export type { RootState } from './rootReducer';

const listenerMiddleware = createListenerMiddleware();

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware()
        .concat(
          meetingsApi.middleware,
          racesApi.middleware,
          raceApi.middleware,
          racePreviewApi.middleware,
          runnersApi.middleware,
          userApi.middleware,
          partnersApi.middleware,
          eventsApi.middleware,
          oddsApi.middleware,
          editorialContentsApi.middleware,
          performancesApi.middleware,
          fixedOddsApi.middleware
        )
        .prepend(listenerMiddleware.middleware),
  });
};
type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
